// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__miWNG","hidden":"Footer_hidden__t13Tc","visible":"Footer_visible__3GqtC"};